import classNames from 'classnames';
import styles from './MissionCard.module.css';
import { ReactNode, useState } from 'react';

import { ReactComponent as CloseSvg } from '../../../Assets/images/close.svg';
import { ReactComponent as CircleInfoSvg } from '../../../Assets/images/circle-info.svg';
import { isDisabled } from '../../../utils/constants';

type MissionCardProps = {
  title?: ReactNode;
  text?: ReactNode | string;
  completed?: boolean;
  locked?: boolean;
  comingSoon?: boolean;
  multiplier?: number;
  header?: ReactNode;
  buttonText?: string | null;
  onClick?: () => void;
  isExpandable?: boolean;
};

export const NewMissionCard = ({
  locked = false,
  comingSoon = false,
  completed = false,
  buttonText,
  title,
  text,
  header = <></>,
  onClick,
  isExpandable = false,
}: MissionCardProps) => {
  const [expanded, setExpanded] = useState(false);

  const displayedTitle = () => (
    <p className="text-white text-center font-poppins md:text-xl text-xs md:leading-[25px] leading-[15px]">
      {expanded ? (
        <>
          {title}
          <span>{text}</span>
        </>
      ) : (
        <span>{title}</span>
      )}
    </p>
  );

  return (
    <div
      className={classNames(
        styles.newCardContainer,
        !comingSoon && styles.newCardPadding,
        'inline-flex flex-col items-center relative',
        Boolean(buttonText) ? 'justify-end' : 'justify-center',
      )}
    >
      {Boolean(title) && (
        <div className={classNames(styles.headerNewCard)}>
          {displayedTitle()}
          {isExpandable && (
            <button onClick={() => setExpanded((prev) => !prev)}>
              {expanded ? <CloseSvg /> : <CircleInfoSvg />}
            </button>
          )}
        </div>
      )}
      <div
        className={classNames([
          'flex flex-col items-center md:gap-2 gap-0 text-center m-auto',
        ])}
      >
        {header}
      </div>
      {Boolean(buttonText) && (
        <button
          className={classNames(
            styles.newCardButton,
            'flex flex-col justify-center items-center',
            completed && styles.completed,
            locked && styles.locked,
            'font-bold text-orange64 cursor-default text-uppercase',
          )}
          onClick={onClick}
          disabled={isDisabled}
        >
          {buttonText}
        </button>
      )}
    </div>
  );
};
